import { createSlice } from "@reduxjs/toolkit";

interface AgencyStateType {
    AgencyError?: string | object | null | undefined | unknown,
    message: any,
    loading: any,
    agency?: any
}
const storedAgency = localStorage.getItem("agencyInfo");
export const initialState: AgencyStateType = {
    AgencyError: null,
    message: null,
    loading: false,
    agency:  storedAgency ? JSON.parse(storedAgency) : null,
};

const AgencySlice = createSlice({
    name: "agency",
    initialState,
    reducers: {
        setAgencySuccessful(state, action) {
            state.agency = action.payload
        },
        setAgencyFailed(state, action) {
            state.agency = action.payload
        },
        clearAgency(state) {
            state.agency = null; // Reset `agency` state
            localStorage.removeItem("agencyInfo"); // Clear it from local storage
        },
    },
});

export const {
    setAgencySuccessful,
    setAgencyFailed,
    clearAgency 
} = AgencySlice.actions

export default AgencySlice.reducer;